import { NormalContainerWithHeader } from '../../shared/components/student/NormalComponent'
import useAuthStore from '../../store/useAuthStore'
import AdminToolbar from '../admin/components/AdminToolbar'
import AccountHistoryTable from './AccountHistoryTable'

const AccountHistory = () => {
    const { user } = useAuthStore()


    return (
        <NormalContainerWithHeader headerText={"Contact Person History"}>
            <AccountHistoryTable id={user?.apartment_id} />
        </NormalContainerWithHeader>
    )
}

export default AccountHistory